jQuery(function ($) {
	"use strict";

	// Back to top
	import './components/back-to-top.js'
	// Shared Constants/Variables
	import './components/browsers.js'
	// Shared Constants/Variables
	import './components/shared-constant.js'
	// In Stock filter. Should be at the top of the list so to have its event handlers at the top of the queue.
	import './components/instock-filter.js'
	// Site Alert
	import './components/site-alert.js'
	// HighRadius payment redirect notice (sidebar "Pay invoices" link only)
	import './components/highradius-redirect-modal.js'
	// Header functionality on site scrolling
	import './components/header-lock.js'
	// Mobile Nav Toggle
	//import './components/mobile-nav.js'
	// Mobile Nav Toggle
	import './components/form-placeholder.js'
	// Megamenu
	import './components/megamenu.js'
	// Accordions
	import './components/accordion-generic.js'
	import './components/mobile-accordion.js'
	// Tooltip
	import './components/tooltip.js'
	// Resize timer
	import './components/resize-timer.js'
	// Clean up after browser resize
	import './components/resize-cleanup.js'
	// Aria Hidden
	import './components/aria-toggle.js'
	// Form generic page
	import './components/generic-page.js'
	// Image Annotations
	import './components/image-annotation.js'
	// Hover Cards
	import './components/hover-card.js'
	// Media Callout
	import './components/media-callout.js'
	// Password Validation
	import './components/password.js'
	// Favorites
	import './components/favorites.js'
	// Favorites Detail
	import './components/favorites-detail.js'
	// Library Hub
	import './components/library-hub.js'
	// Quickview
	import './components/quickview.js'
	// PDP
	import './components/pdp.js'
	// Slick Carousel
	import './components/slick-carousel.js'
	// Wishlist Dropdown
	import './components/wishlist-dropdown.js'
	// PTP Filter
	import './components/ptp-filter.js'
	// NL Search Bar
	import './components/nl-search-bar.js'
	// Form Validation
	import './components/form-validation.js'
	// Country/State Form field
	import './components/country-form.js'
	// Mobile Search Toggle
	import './components/mobile-search.js'
	// Search Bar
	import './components/search-bar.js'
	// Circle Animation
	import './components/circle-animation.js'
	// Datatable Dashboard
	import './components/datatable-dashboard.js'
	// Dashboard Nav Toggle
	import './components/dashboard-nav-toggle.js'
	// datatables
	// Order Details
	import './components/order-details.js'
	// Search Box
	import './components/search-box.js'
	// Search Bar
	import './components/dropdown-accessibility.js'
	// General Form
	import './components/form.js'
	// DataTables Sort
	import './components/table-sort.js'
	// Cart Functions
	import './components/shopping-cart.js' // There's a handler in this file which must be executed after handler in form.js. Keep the order!
	// Request Datepicker
	import './components/request-date.js'
	// File A Claim Table
	import './components/file-a-claim.js'
	// Checkout Dashboard
	import './components/checkout-form.js'
	// AJAX Validation
	import './components/ajax-validation.js'
	// Account Settings
	import './components/account-settings.js'
	// Store Locator
	import './components/store-locator.js'
	// Account Settings
	import './components/manage-users.js'
	// Date Range Picker
	import './components/daterange-picker.js'
	// Address Book
	import './components/address-book.js'
	// Claim Form
	import './components/claim-form.js'
	// Contact Form
	import './components/contact-form.js'
	import './components/reorder.js'
	// Global Utils Functions
	import './components/utils.js'

	import './components/ga4.js'
	import './components/ga4-integration.js'
	// HawkSearch Event Tracking
	import './components/hawksearch-tracking.js'
}(jQuery));
// Init Animate on Scroll Plugin
AOS.init();

import './components/fluidpay-checkout.js'
